export const whiteNotchedOutline = {
    '& .MuiOutlinedInput-notchedOutline': {
        background: '#fff'
    }
};
